module.exports = __webpack_public_path__ + "static/media/portfolio-managers.f526d472.png";